import { useEffect, useState } from "react"
import { IOpenPanel } from "../../../../Interfaces/IPanel"
import { ICatalogoInseguro, IFilterListaHazardRequest, IListaHazardRequest } from "../../../../Interfaces/hazard/IHazard"
import { IPanelFilter, PanelFilter } from "../../../../components/Panel/PanelFilter"
import { ComboBoxComponent } from "../../../../components/comboBox/ComboBoxComponent"
import { UseComboIncidente } from "../../../../hooks/hazard/combo/UseComboIncidente"
import { UseComboElementoEstandar } from "../../../../hooks/hazard/combo/UsoComboElementoEstandar"
import { UseComboGeneric } from "../../../../hooks/hazard/combo/UseComboGeneric"
import { CatalogoInseguroService } from "../../../../services/hazard/catalogoInseguroService"
import { TextField } from "@fluentui/react"

export interface IFiltroHazard extends IOpenPanel{
    filtro:IFilterListaHazardRequest
    setFiltro:  React.Dispatch<React.SetStateAction<IFilterListaHazardRequest>>
    resetFilter: () => void;
    buscar: () => void;
}
export const FiltroHazard=(props:IFiltroHazard)=>{
    const onChangeFecha=(key:string,value:string)=>{
        props.setFiltro({...props.filtro,[key]:value})
    }
    const { dataComboIncidente, onChange } = UseComboIncidente(props.isOpen);
    const { dataComboElemento, onChangeElemento } = UseComboElementoEstandar(props.isOpen);
    const [filterCondicion, setFilterCondicion] = useState<ICatalogoInseguro>({
        skip: 0,
        take: 20,
        search: '',
        esCondicion: true,
    });
    const [filterActo, setFilterActo] = useState<ICatalogoInseguro>({
        skip: 0,
        take: 20,
        search: '',
        esCondicion: false,
    });
    const comboCondiciones = UseComboGeneric({isOpen:props.isOpen,filter:filterCondicion,
    setFilter:setFilterCondicion,fetchData:CatalogoInseguroService.ComboCatalogoInseguro});
    const comboActos = UseComboGeneric({isOpen:props.isOpen,filter:filterActo,
    setFilter:setFilterActo,fetchData:CatalogoInseguroService.ComboCatalogoInseguro});



    return (<PanelFilter isOpen={props.isOpen} onDismiss={props.onDismiss} textHeader={"Filtro Registros Hazard"} resetFilter={props.resetFilter} 
    buscar={props.buscar} >
    <div className="ms-Grid" dir="ltr">
    <ComboBoxComponent
                    text="Incidente:"
                    selectedKey={props.filtro.incidenteKey}
                    placeholder="Seleccione un Incidente"
                    value={props.filtro.incidenteText}
                    onChange={onChange}
                    onOptionSelect={(event, option) => {
                        if(option!=undefined){
                            props.setFiltro({...props.filtro,incidenteKey:option.key.toString(),incidenteText:option.text})
                        }
                    }}
                    defaultSelectedOptions={[{
                        key: props.filtro.incidenteKey==undefined?"":props.filtro.incidenteKey.toString(),
                        text: props.filtro.incidenteText==undefined?"":props.filtro.incidenteText.toString()
                    }]}
                    data={dataComboIncidente}
                />
     <ComboBoxComponent
                    text="Elemento Estandar:"
                    selectedKey={props.filtro.elementoEstandarKey}
                    placeholder="Seleccione un Elemento Estandar"
                    value={props.filtro.elementoEstandarText}
                    onChange={onChangeElemento}
                    onOptionSelect={(event, option) => {
                        if(option!=undefined){
                            props.setFiltro({...props.filtro,elementoEstandarKey:option.key.toString(),elementoEstandarText:option.text})
                        }
                    }}
                    defaultSelectedOptions={[{
                        key: props.filtro.elementoEstandarKey==undefined?"":props.filtro.elementoEstandarKey.toString(),
                        text: props.filtro.elementoEstandarText==undefined?"":props.filtro.elementoEstandarText.toString()
                    }]}
                    data={dataComboElemento}
                />
     <ComboBoxComponent
                    text="Condicion Insegura:" 
                    selectedKey={props.filtro.condicionInseguraKey}
                    placeholder="Seleccione una Condición Insegura"
                    value={props.filtro.condicionInseguraText}
                    onChange={comboCondiciones.onChangeGeneric}
                    onOptionSelect={(event, option) => {
                        if(option!=undefined){
                            props.setFiltro({...props.filtro,condicionInseguraKey:option.key.toString(),condicionInseguraText:option.text})
                        }
                    }}
                    defaultSelectedOptions={[{
                        key: props.filtro.condicionInseguraKey==undefined?"":props.filtro.condicionInseguraKey.toString(),
                        text: props.filtro.condicionInseguraText==undefined?"":props.filtro.condicionInseguraText.toString()
                    }]}
                    data={comboCondiciones.dataCombo}
                />
    <ComboBoxComponent
                    text="Acto Inseguro:"
                    selectedKey={props.filtro.actoInseguroKey}
                    placeholder="Seleccione un Acto Inseguro"
                    value={props.filtro.actoInseguroText}
                    onChange={comboActos.onChangeGeneric}
                    onOptionSelect={(event, option) => {
                        if(option!=undefined){
                            props.setFiltro({...props.filtro,actoInseguroKey:option.key.toString(),actoInseguroText:option.text})
                        }
                    }}
                    defaultSelectedOptions={[{
                        key: props.filtro.actoInseguroKey==undefined?"":props.filtro.actoInseguroKey.toString(),
                        text: props.filtro.actoInseguroText==undefined?"":props.filtro.actoInseguroText.toString()
                    }]}
                    data={comboActos.dataCombo}
                />
    <TextField
                    type="date"
                    label="Desde"
                    placeholder="Ingrese Fecha"
                    autoComplete="off"
                    value={props.filtro.fechaInicio}
                    onChange={(event, newValue) => {
                        if(newValue!=undefined){
                            onChangeFecha("fechaInicio",newValue)
                        }
                    }}
                />
                <br/>
                <TextField
                    type="date"
                    label="Hasta"
                    placeholder="Ingrese Fecha"
                    autoComplete="off"
                    value={props.filtro.fechaFin}
                    onChange={(event, newValue) => {
                        if(newValue!=undefined){
                            onChangeFecha("fechaFin",newValue)
                        }
                    }}
                    
                /> 
    
    

    </div>
    </PanelFilter>)
}